export default __webpack_public_path__ + "static/media/mich-chron-dec.2a5eda1a.webp";